import React from "react";

const invoices = [
  // {
  //   invoiceNumber: "#INV380114-3GhOs380",
  //   number: "18553957161",
  //   amount: "$ 0",
  //   paymentFor: "free",
  //   paymentType: "free",
  //   status: "Free",
  //   date: "14 Jan 2025 19:27:26",
  // },
  // Add more invoice entries here if needed...
];

export default function InvoiceHistory() {
  return (
    <div className="bg-white p-2 rounded-lg shadow-lg">
      <div className="mx-auto">
        <div className="bg-white py-6">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <h1 className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
                  Invoice History
                </h1>

                <p className="mt-2 text-sm text-gray-500">
                  View and manage your invoice records.
                </p>
              </div>
            </div>
            <div className="mt-4">
              <input
                type="text"
                placeholder="Search invoices..."
                className="w-full text-gray-900 px-4 py-2 text-xs placeholder:text-gray-500 rounded-lg border border-gray-700"
              />
            </div>
            <div className="mt-6 flow-root">
              <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <table className="min-w-full divide-y divide-gray-700">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="py-3.5 pl-4 pr-3 text-left text-xs font-medium text-gray-900 sm:pl-0"
                        >
                          Invoice Number
                        </th>

                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-xs font-medium text-gray-900"
                        >
                          Number
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-xs font-medium text-gray-900"
                        >
                          Amount
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-xs font-medium text-gray-900"
                        >
                          Payment For
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-xs font-medium text-gray-900"
                        >
                          Payment Type
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-xs font-medium text-gray-900"
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-xs font-medium text-gray-900"
                        >
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-800">
                      {invoices.map((invoice, index) => (
                        <tr key={index}>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                            {invoice.invoiceNumber}
                          </td>

                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {invoice.number}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {invoice.amount}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {invoice.paymentFor}
                          </td>

                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {invoice.paymentType}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {invoice.status}
                          </td>

                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {invoice.date}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
